<mat-toolbar class="topbar">
  <app-branding></app-branding>

  <!-- --------------------------------------------------------------- -->
  <div class="hamburger_group">
    <!-- Desktop Menu -->
    @if (showToggle) {
    <button mat-icon-button (click)="toggleCollapsed.emit()" class="d-flex justify-content-center">
      <i-tabler name="menu-2" class="icon-20"></i-tabler>
    </button>
    }

    <!-- Mobile Menu -->
    @if (!showToggle) {
    <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center">
      <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
    </button>
    }
  </div>

  <div class="buttons-icon-group d-flex align-items-center gap-20">
    <!-- MFA Activation Hint Icon -->
    @if (!mfaEnabled && !isMobile) {
    <a mat-raised-button class="mfa-button" matToolTip="Attiva Autenticazione a due fattori"
      routerLink="/anagrafica/configura-mfa">
      <div>
        {{ "HEADER.ACTIVATE_MFA" | translate }}
      </div>
      <i-tabler name="shield-lock" class="mfa-shield pulse"></i-tabler>
    </a>
    }

    <!-- Zoom controls -->
    <div class="d-flex" style="gap: 6px">
      <button mat-icon-button matTooltip="Riduci" (click)="decreaseZoom()" class="cursor-pointer">
        <i-tabler name="zoom-out" class="icon-20 d-flex"></i-tabler>
      </button>
      <button mat-icon-button matTooltip="Ingrandisci" (click)="increaseZoom()" class="cursor-pointer">
        <i-tabler name="zoom-in" class="icon-20 d-flex"></i-tabler>
      </button>
    </div>


    <!--
    <button *ngIf="showNotifications"
      mat-icon-button
      [matMenuTriggerFor]="notificationmenu"
      aria-label="Notifications"
      class="m-r-20">
      <mat-icon [matBadge]="messages.length"
        matBadgeOverlap="false"
        matBadgeColor="warn"
      class="header-badge">message</mat-icon>
    </button>
    <mat-menu #notificationmenu="matMenu"
      class="topbar-dd cardWithShadow">
      <div class="d-flex align-items-center p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0">Messaggi</h6>
        <span class="m-l-auto">
          <span *ngIf="!loading.value"
          class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">0 nuove</span>
        </span>

      </div>

      <ng-container *ngIf="messages && messages.length">

        <div class="p-y-12 p-x-32">
          <button routerLink="/news"
            mat-stroked-button
            color="primary"
            class="w-100">
            Visualizza tutte
          </button>
        </div>
        <mat-divider></mat-divider>

        <div class="message_dropdown_list">
          <button mat-menu-item
            class="p-x-32 p-y-16 d-block"
            *ngFor="let message of messages">
            <div class="d-flex align-items-center">
              <div>
                <div class="d-flex align-items-center justify-content-between">
                  <h5 class="f-s-14 f-w-600 m-0 mat-subtitle-1">
                    {{message.title}}
                  </h5>
                </div>
                <span class="f-s-12">{{message.date | date : 'short' }}</span>
              </div>
            </div>
          </button>

        </div>

      </ng-container>

      <ng-template #noNotifications>

      </ng-template>

    </mat-menu> -->

    <!-- change language -->
    @if (showLanguageSwitcher === true && !isMobile) {
    <button mat-icon-button matTooltip="{{ 'HEADER.CHANGE_LANGUAGE' | translate }}" (click)="onDemandLanguageSwitch()"
      class="cursor-pointer language-flag">
      <img [src]="flagImgSrc" width="25" (error)="onFlagImgError()" />
    </button>
    }

    <!-- --------------------------------------------------------------- -->
    <!-- profile Dropdown -->
    <!-- --------------------------------------------------------------- -->
    <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="profile">
      <img src="/assets/images/users/profile.png" class="rounded-circle object-cover" width="35" alt="profile" />
    </button>

    <mat-menu #profilemenu="matMenu" class="topbar-dd">
      <ng-scrollbar class="position-relative" [autoHeightDisabled]="false">
        <div class="p-x-32 p-y-16">
          <h6 class="f-s-16 f-w-600 m-0">
            {{ "HEADER.USER_PROFILE" | translate }}
          </h6>

          <div class="p-b-24 b-b-1 m-t-16">
            <div class="d-flex align-items-center m-b-32">
              <img src="/assets/images/users/profile.png" class="rounded-circle" width="95" alt="profile" />
              <div class="m-l-16">
                <p class="f-s-14 f-w-500 m-0">{{ "WELCOME" | translate }}</p>
                <h6 class="f-s-18 f-w-600 m-0">{{ username }}</h6>
                <!-- <span class="f-s-14 d-block m-b-4">{{"HEADER.TYPOLOGY" | translate}}
              {{"HEADER."+ role | translate}}</span> -->
              </div>
            </div>

            <!-- MFA -->
            @if (
            enabledForRole("user-details", "MfaConfigurationPageComponent")
            ) {
            <button mat-raised-button class="w-100 m-t-16 d-flex gap-10" color="primary"
              routerLink="/anagrafica/configura-mfa">
              <i-tabler name="shield-lock"></i-tabler>
              {{ "HEADER.MFA_CONFIGURATION" | translate }}
            </button>
            }

            <!-- change password -->
            @if (
            enabledForRole("user-details", "UserChangePasswordPageComponent")
            ) {
            <button mat-stroked-button class="w-100 m-t-16" color="primary" routerLink="/anagrafica/modifica-password">
              <i-tabler name="key"></i-tabler>
              {{ "HEADER.CHANGE_PASSWORD" | translate }}
            </button>
            }

            <!-- settings -->
            @if (user?.isNet() && isMobile) {
            <button mat-stroked-button class="w-100 m-t-16" color="primary">
              {{ "HEADER.SETTINGS" | translate }}
            </button>
            }

            <!-- change language -->
            @if (showLanguageSwitcher === true && isMobile) {
            <button mat-stroked-button class="w-100 m-t-16" color="primary" (click)="onDemandLanguageSwitch()">
              {{ "HEADER.CHANGE_LANGUAGE" | translate }}
            </button>
            }
          </div>
        </div>

        <div class="p-y-12 p-x-32">
          <a (click)="logout()" mat-stroked-button color="warn" class="w-100">
            {{ "HEADER.LOGOUT" | translate }}
            <i-tabler name="logout"></i-tabler>
          </a>
        </div>
      </ng-scrollbar>
    </mat-menu>
  </div>
</mat-toolbar>